export default __webpack_public_path__ + "static/media/03_photo.ff9eeabe.jpg";